<template>
  <v-container class="pa-0">
    <v-dialog  class="pa-0 display-unset" v-model="dialog" width="500">

      <v-btn color="primary darken-2 no-shadow card-r right" slot="activator" dark>Save</v-btn>


      <div center class="text-xs-center">
        <v-avatar color="primary" size="125" >
          <v-icon dark class="f-130">check_circle</v-icon>
        </v-avatar>
        <v-icon class="mb-5"></v-icon>
      </div>
      <v-card class="card-pop card-r no-shadow pa-3">
        <div  class="pt-3 mt-5 text-xs-center">
         <span class="f-20">
            Do you confirm?
         </span>
        </div>
        <v-layout>
          <v-flex>
                <v-flex xs12 class="pt-2">
                  <v-list>

                    <v-card color="grey lighten-2" class="mt-2 pt-3 pa-2 mb-2 card-r no-shadow">
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="primary" class="f-30">fas fa-check-circle</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title>{{value1}}</v-list-tile-title>
                        </v-list-tile-content>

                      </v-list-tile>
                    </v-card>
                    <v-card color="grey lighten-2" class="mb-4 pt-3 pa-2 card-r no-shadow">
                      <v-list-tile>
                        <v-list-tile-action>
                          <v-icon color="primary" class="f-">fas fa-check-circle</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title>{{value2}}</v-list-tile-title>
                        </v-list-tile-content>

                      </v-list-tile>
                    </v-card>
                  </v-list>

                </v-flex>
                <v-layout xs12>
                  <v-flex xs12 class="text-xs-left mr-1">
                    <v-btn @click="dialog = false" color="grey lighten-2" class="btn-customer no-shadow card-r">Cancel</v-btn>
                  </v-flex>
                  <v-flex xs12 class="text-xs-right ml-1">
                    <v-btn @click="confirmyes(); dialog = false" class="btn-customer card-r primary text-white no-shadow card-r">Confirm</v-btn>
                  </v-flex>
                </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
	/* eslint-disable */
  export default {
    data () {
      return {
        dialog: false
      }
    },
    methods:{
        confirmyes(){
            this.$emit('confirmyes')
        }
    },
    props:[
          'value1',
          'value2'
    ],
    created:()=>{
    }
  }
</script>
<style lang="stylus" scoped>
.v-progress-circular
  margin: 1rem
.card-pop{
  z-index: -4;
  margin-top: -12%;
}
.v-dialog{
  box-shadow: none!important;
}
.btn-customer{
  margin: 6px 0px 6px 0px !important;
  height: 45px;
  width: 100%;
}
  .text-white{
    color: #ffffff!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/WidgetComponents/ConfirmPopup.vue